module.exports = __webpack_public_path__ + "static/media/magnifier.92520766.png";